// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils from "../utils/ErrorUtils.bs.jsx";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

function isFirebaseError(exn) {
  return Stdlib_JsExn.name(exn) === "FirebaseError";
}

let EmailChangeNeedsVerification = /* @__PURE__ */Primitive_exceptions.create("FirebaseError.EmailChangeNeedsVerification");

let EmailExists = /* @__PURE__ */Primitive_exceptions.create("FirebaseError.EmailExists");

let InvalidPassword = /* @__PURE__ */Primitive_exceptions.create("FirebaseError.InvalidPassword");

let NeedConfirmation = /* @__PURE__ */Primitive_exceptions.create("FirebaseError.NeedConfirmation");

let TooManyRequests = /* @__PURE__ */Primitive_exceptions.create("FirebaseError.TooManyRequests");

let UnverifiedEmail = /* @__PURE__ */Primitive_exceptions.create("FirebaseError.UnverifiedEmail");

let WeakPassword = /* @__PURE__ */Primitive_exceptions.create("FirebaseError.WeakPassword");

function toFirebaseError(exn) {
  if (exn.RE_EXN_ID !== "JsExn") {
    return exn;
  }
  let obj = exn._1;
  if (Stdlib_JsExn.name(obj) !== "FirebaseError") {
    return exn;
  }
  let match = ErrorUtils.code(obj);
  if (match === undefined) {
    return exn;
  }
  switch (match) {
    case "auth/account-exists-with-different-credential" :
      return {
        RE_EXN_ID: NeedConfirmation
      };
    case "auth/email-already-in-use" :
      return {
        RE_EXN_ID: EmailExists
      };
    case "auth/email-change-needs-verification" :
      return {
        RE_EXN_ID: EmailChangeNeedsVerification
      };
    case "auth/too-many-requests" :
      return {
        RE_EXN_ID: TooManyRequests
      };
    case "auth/unverified-email" :
      return {
        RE_EXN_ID: UnverifiedEmail
      };
    case "auth/weak-password" :
      return {
        RE_EXN_ID: WeakPassword
      };
    case "auth/wrong-password" :
      return {
        RE_EXN_ID: InvalidPassword
      };
    default:
      return exn;
  }
}

export {
  isFirebaseError,
  EmailChangeNeedsVerification,
  EmailExists,
  InvalidPassword,
  NeedConfirmation,
  TooManyRequests,
  UnverifiedEmail,
  WeakPassword,
  toFirebaseError,
}
/* Stdlib_JsExn Not a pure module */
